import React from 'react';
import { View } from '@react-pdf/renderer';
import { styles } from '../styles';
import { OrderTotalsBox } from './OrderTotalsBox';

export const OrderFinalization = ({ order, totalPrice }) => (
  <View style={styles.orderInfo} wrap={false}>
    <View style={styles.row}>
      <View style={styles.columna} />
      <View style={styles.columnb}>
        <OrderTotalsBox totalPrice={totalPrice} order={order} />
      </View>
    </View>
  </View>
);
